/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenderDto } from '../../models/tender-dto';
import { TenderResponseModel } from '../../models/tender-response-model';

export interface CreateTender$Params {
      body: TenderDto
}

export function createTender(http: HttpClient, rootUrl: string, params: CreateTender$Params, context?: HttpContext): Observable<StrictHttpResponse<TenderResponseModel>> {
  const rb = new RequestBuilder(rootUrl, createTender.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenderResponseModel>;
    })
  );
}

createTender.PATH = '/tenders';
